<template>
  <MainPage :withArticles="false" :withEvents="false" v-if="loaded">
    <div class="memories-page">
      <div class="page-wrapper">
        <MemoryForm />
      </div>
    </div>
  </MainPage>
</template>

<script>
import _ from "lodash";
import MemoryForm from "@/components/Memory/MemoryForm";
import MainPage from "./main.page";

export default {
  name: "MemoriesPage",
  metaInfo: {
    titleTemplate: "%s - Memories",
  },
  components: { MemoryForm, MainPage },
  data() {
    return {
      search: "",
      memories: [],
      page: 1,
      infiniteId: +new Date(),
      pageIds: [],
      memoryPageDialog: false,
      showTags: false,
      loaded: false,
    };
  },
  created() {
    this.setPageContext("stories", () => {
      this.loaded = true;
    });
  },
  methods: {
    openNewMemoryDialog() {
      this.memoryPageDialog = true;
    },
    async fetchMemories($state) {
      const params = {
        page_ids: this.pageIds,
        page: this.page,
        query: this.search,
        self_posted: false,
      };
      const { data } = await this.$api.Memory.query(params);
      this.page += 1;
      const ids = this.memories.map((t) => t.id);
      const newData = data.filter((t) => !ids.includes(t.id));

      this.memories.push(...newData);

      if (data.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setInfiniteId: _.debounce(function() {
      this.page = 1;
      this.memories = [];
      this.infiniteId += 1;
    }, 300),
  },
  watch: {
    search() {
      this.setInfiniteId();
    },
  },
};
</script>

<style scoped lang="scss">
.memories-page {
  &__grid {
    margin-top: 60px;
    min-height: 200px;
    position: relative;
  }

  .share-memory-btn::v-deep .v-btn__content {
    font-size: 12px;
  }
}

@media screen and (max-width: 960px) {
  .memories-page {
    &__grid {
      margin-top: -20px;
      margin-bottom: 40px;
    }
  }
}
</style>
